import {getNewOutlet} from 'reconnect.js';
import './featureOptions';

/**
 * **************************************************
 * common / basic
 * **************************************************
 */
getNewOutlet('devMode', false, {autoDelete: false});
getNewOutlet('user', null, {autoDelete: false});
getNewOutlet('landing', null, {autoDelete: false});
getNewOutlet('locale', {lang: 'tw'}, {autoDelete: false});
getNewOutlet('area', 'doctor', {autoDelete: false});
getNewOutlet('about', null, {autoDelete: false});
getNewOutlet('config', null, {autoDelete: false});
getNewOutlet('footerConfig', null, {autoDelete: false});
getNewOutlet('navbarConfig', null, {autoDelete: false});
getNewOutlet('dimension', {rwd: 'mobile'}, {autoDelete: false});
getNewOutlet('actions', null, {autoDelete: false});
getNewOutlet('ApiUtil', {}, {autoDelete: false});
getNewOutlet(
  'cart',
  {
    items: [],
    extra_items: [],
    discount_items: [],
  },
  {autoDelete: false},
);
getNewOutlet(
  'routes',
  {
    getRoute: (route, params) => {
      return null;
    },
  },
  {autoDelete: false},
);

/**
 * **************************************************
 * modal / spinner related
 * **************************************************
 */
getNewOutlet('loading', false, {autoDelete: false});
getNewOutlet('login-modal', false, {autoDelete: false});
getNewOutlet('reset-password-modal', false, {autoDelete: false});
getNewOutlet('file-upload-modal', false, {autoDelete: false});
getNewOutlet('newsletter-modal', null, {autoDelete: false});

/**
 * **************************************************
 * product / article related
 * **************************************************
 */
const defaultCats = [
  {
    name: 'all',
    display: '所有分類',
    items: [],
  },
];

defaultCats.meta_data = {
  img_url: '',
};

getNewOutlet(
  'sortOptions',
  [
    {name: '-created', display: '上架時間(由新到舊)'},
    {name: 'created', display: '上架時間(由舊到新)'},
    {name: 'price', display: '價格(由低到高)'},
    {name: '-price', display: '價格(由高到低)'},
  ],
  {autoDelete: false},
);

getNewOutlet(
  'articleSortOptions',
  [
    {name: '-created', display: '發布時間(由新到舊)'},
    {name: 'created', display: '發布時間(由舊到新)'},
  ],
  {autoDelete: false},
);
getNewOutlet('salesEventCategories', defaultCats, {autoDelete: false});
getNewOutlet('selected-orders', [], {autoDelete: false});
getNewOutlet('products', [], {autoDelete: false});
getNewOutlet('articles', [], {autoDelete: false});
getNewOutlet('customer_support_config', {options: []}, {autoDelete: false});

getNewOutlet('site', [], {autoDelete: false});
